import dataDownloadReducer from "./dataDownloadReducer";

const cropCertificationDataDownloadReducer = {
    cropCertificationDataDownload: dataDownloadReducer
}

export default cropCertificationDataDownloadReducer